import { addInputDays } from "../../utils/date.js";

// Totals are over the same dates/bars the chart displays, grouped Monday–Sunday.
// This includes weekend activity and the visible portion of a boundary week.
export function dailyChartWeeks(daily) {
  const weeks = new Map();
  for (const day of daily) {
    const weekday = new Date(`${day.day}T00:00:00Z`).getUTCDay();
    const weekStart = addInputDays(day.day, -((weekday + 6) % 7));
    if (!weeks.has(weekStart)) weeks.set(weekStart, { weekStart, firstDay: day.day, lastDay: day.day, total: 0 });
    const week = weeks.get(weekStart);
    week.firstDay = day.day < week.firstDay ? day.day : week.firstDay;
    week.lastDay = day.day > week.lastDay ? day.day : week.lastDay;
    week.total += Number(day.logged) || 0;
  }
  return [...weeks.values()];
}
